import type { FaireProductEntity } from "../../entity_types/product";

export const p_npyf9j8adk: FaireProductEntity = {
  token: "p_npyf9j8adk",
  type: "product",
  name: "California Poppy Embroidered Unisex Shirt MINERAL WASH Tee - MADE IN USA",
  brandToken: "b_9ha1ebi2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5d0387f7f31491d28dad4941e5b300d791eba1c3c3d400feeb75032819f45a1a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6311139779a9126fa94dda3d79245a5fe632f92a68f15f6a97d1e0fbfa269b83.jpeg",
  ],
  priceDollars: 31.87,
  description:
    "\nUNISEX EMBROIDERED COTTON POPPY SHIRT\n\nCalifornia Poppy T shirt is perfect addition to your drawer. This California poppy embroidery is done right in house.\n\nThese 100% cotton embroidered California Poppy tees are all you need for comfort with a touch of artistic pop. I hand drew each California Poppy and these are embroidered right in the back of the shop. I have been on the search for the perfect cotton pocket tees for this design and found them. These shirts are incredible fit and MADE IN USA.\n\nEmbroidered at the shop!\n100% Mineral Washed Cotton\nMADE UN USA\nOriginal Design By Jamai Lowell\n\nUnisex Sizing (size accordingly) \n\n\n\nFABRIC: Premium Jersey 100% Combed Ring Spun Cotton 6.",
  tags: [],
  msrpDollars: 63.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:10.516Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
